// extracted by mini-css-extract-plugin
module.exports = {"deviceSelectionContainer":"DeviceSelection_deviceSelectionContainer__gFk_0"};